import React from 'react';
import './HaveQuestions.css';
import location from '../../assets/images/location.png'
import banner from '../../assets/images/pic_5.png'
import locationbottom from '../../assets/images/Icons_and_images/location_bottom_blue.png';
import mobilebottom from '../../assets/images/Icons_and_images/site reporting hover.png';
import timebottom from '../../assets/images/Icons_and_images/time.png';
import { Link } from 'react-router-dom';
import { Button } from 'bootstrap';

//import banner from '../../assets/images/home_banner_without_text.png'
const Footer = () => (
    <div className='padbot' >
        <div className="havequesdiv havequestions-font">
            <div class="row ">
            <div class="col-lg-12  col-md-12 col-sm-12 col-12 ">
    <center>  <p className='bluehead9'>&lt;&lt;&lt; &nbsp;&nbsp;Contact Us &nbsp;&nbsp; &gt;&gt;&gt;</p></center>
    <center>  <p className='blackhead4'>Elevating Your Business Beyond Boundaries</p></center>
    <center>  <Link to = '/RequestDemo'>
    <button className='blackh mt-3'>
      Get In Touch</button></Link></center>
        </div>
                <div class=" col-md-12 col-lg-12 col-sm-12  col-12  "  >
                <div className="row pt-5">
                <div className="col-lg-2 col-xl-2 col-md-1"> </div>

        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12  col-12">
        <div className="section" style={{ position: 'relative' }}>
            
        <div className="row">
        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-2  col-2">
            <img src={locationbottom} alt="not found" width={50} height={50} />
</div>
<div className="col-xl-9 col-lg-9 col-md-9 col-sm-10  col-10 mt-1">
            <font className="footer-text1  ">Athees Info Solutions<br />4/743, vishwashanthi nagar,<br />
                                             bank colony stop,<br />
                                            madurai – 625014.</font>
           
                                            </div>
                                            </div>

          </div>
        </div>
        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12  col-12 ">
          <div class="divider"></div>
          <div className="section" style={{ position: 'relative' }}>
          <div className="row">
        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-2  col-2">
            <img className='distance' src={mobilebottom} alt="not found" width={80} height={80} />
            </div>
            <div className="col-xl-9 col-lg-9 col-md-9 col-sm-10  col-10 mt-2">
            <font className="footer-text1 ">
            finance.hr@aais.co.in
              <br/>
              +91 9994174786
            </font>
            </div>
</div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12  col-12  ">
        <div className="col-lg-1 col-xl-1"> </div>

        <div className="section" style={{ position: 'relative' }}>
        <div className="row">
        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-2  col-2">
                        <img  src={timebottom} alt="not found" width={50} height={50} />
                        </div>
                        <div className="col-xl-9 col-lg-9 col-md-9 col-sm-10  col-10 mt-2">
            <font className="footer-text1">
              Mon-Sat: 6AM to 8PM
              <br/>
              Sunday: CLOSED
            </font>
            </div>
            </div>
          </div>
        </div>
      </div>
                </div>
            </div>
            </div>
        </div>
)
export default Footer;